import { inject, Injectable } from "@angular/core";
import { DomainService } from "./domain.service";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class ThemeService {
  readonly domainService = inject(DomainService);
  readonly http = inject(HttpClient);
  readonly assetUrl = this.domainService.wlAssetURL;
  defaultLoginTemplate = "";
  readonly defaultLoginTemplatePath = "assets/white-labels/freedemokit.com/login.html";

  constructor() {
    this.fetchDefaultTemplate().subscribe({
      next: (template) => {
        this.defaultLoginTemplate = template;
      },
    });
  }

  loadTheme(): void {
    const domain = this.domainService.getDomain();
    const themeClass = domain.replace(".", "_");
    document.body.classList.add(themeClass);
  }

  fetchLoginTemplate() {
    return this.http.get(`${this.assetUrl}/login.html`, {
      responseType: "text",
    });
  }

  fetchLandingTemplate() {
    return this.http.get(`${this.assetUrl}/landing.html`, {
      responseType: "text",
    });
  }

  fetchRegisterTemplate() {
    return this.http.get(`${this.assetUrl}/register.html`, {
      responseType: "text",
    });
  }

  fetchFooterTemplate() {
    return this.http.get(`${this.assetUrl}/footer.html`, {
      responseType: "text",
    });
  }

  fetchDefaultTemplate() {
    return this.http.get(this.defaultLoginTemplatePath, {
      responseType: "text",
    });
  }
}
